import { render, staticRenderFns } from "./vip-phone-login.vue?vue&type=template&id=10abdd46&scoped=true&"
import script from "./vip-phone-login.vue?vue&type=script&lang=js&"
export * from "./vip-phone-login.vue?vue&type=script&lang=js&"
import style0 from "./vip-phone-login.vue?vue&type=style&index=0&id=10abdd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abdd46",
  null
  
)

export default component.exports